import { useEffect } from 'react';
import { useParams } from 'react-router';
import { api } from '@/api/core';
import { useCaseCloningLock } from '@/hooks';
import {
  setSharedDataActiveBundleType,
  setSharedDataBundleId,
  BundleType,
  useAppDispatch,
  useAppSelector,
  selectSharedDataActiveBundleType,
} from '@/store';
import { DocumentReviewPage } from './DocumentReviewPage';
import { useGetPageIdInViewportOnInit } from './hooks';

export const FullBundlePageContainer = () => {
  const dispatch = useAppDispatch();
  const { caseId, fullBundleId } = useParams();
  const activeBundleType = useAppSelector(selectSharedDataActiveBundleType);

  useGetPageIdInViewportOnInit();
  useCaseCloningLock(caseId);

  useEffect(() => {
    dispatch(setSharedDataBundleId(fullBundleId || null));
    dispatch(setSharedDataActiveBundleType(BundleType.FULL));

    return () => {
      dispatch(setSharedDataBundleId(null));
      dispatch(setSharedDataActiveBundleType(null));
      dispatch(api.util.resetApiState());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (activeBundleType !== BundleType.FULL) {
    return null;
  }

  return <DocumentReviewPage />;
};
